import { LoaderFunctionArgs } from 'react-router';

import type { TDeploymentRequestCrumbData } from '@/console/app/routes/deployment-requests/deployment-request';
import { DEPLOYMENTS_SEGMENT_QUERY_PARAM } from '@/console/features/deployment-requests/deployment-requests.constants';
import { TCrumb, TCustomRouteObject } from '@/shared/types/router.types';

const devicesCrumb: TCrumb = {
  label: 'devices',
  localized: true,
  link: '/devices',
};

// A request is opened from its device's Deployments tab, but the page is not a child
// route of the device, so the trail back has to be built here. The device crumb returns
// to the requests list rather than to the jobs the tab opens on by default.
const getDeviceAncestor = (data: TDeploymentRequestCrumbData): TCrumb =>
  data?.deviceName
    ? {
        label: data.deviceName,
        link: `/devices/${data.deviceId}/deployments?${DEPLOYMENTS_SEGMENT_QUERY_PARAM}=requests`,
        ancestor: devicesCrumb,
      }
    : devicesCrumb;

export const deploymentRequestsRoutes: TCustomRouteObject = {
  path: '/deployment-requests/:deploymentRequestId',
  lazy: async () => {
    const { DeploymentRequestDetail } =
      await import('@/console/app/routes/deployment-requests/deployment-request');
    return { Component: DeploymentRequestDetail };
  },
  loader: async (args: LoaderFunctionArgs) => {
    const { deploymentRequestLoader } =
      await import('@/console/app/routes/deployment-requests/deployment-request');
    return deploymentRequestLoader(args);
  },
  handle: {
    crumb: {
      label: 'deployment_requests',
      localized: true,
      ancestor: getDeviceAncestor,
    },
    permission: { action: 'device:readDevice' },
  },
};
